import React from 'react';
import {Talent2} from "../../../assets";

const InstructionSection = () => {
  const stepsData = [
    {
      number: 1,
      title: 'Pastikan koneksi Internet Stabil',
      circleColor: 'bg-[#1e3e7e]',
      textColor: 'text-[#1e3e7e]',
    },
    {
      number: 2,
      title: 'Setiap test memiliki batas waktu',
      circleColor: 'bg-[#a51c30]',
      textColor: 'text-[#a51c30]',
    },
    {
      number: 3,
      title: 'Hasil tidak akan disimpan otomatis',
      circleColor: 'bg-[#1e3e7e]',
      textColor: 'text-[#1e3e7e]',
    },
    {
      number: 4,
      title: 'Jika ada kendala, hubungi admin melalui WhatsApp',
      circleColor: 'bg-[#a51c30]',
      textColor: 'text-[#a51c30]',
    },
  ];

  return (
    <section className="py-12 px-6 md:px-12 lg:px-24">
      {/* Judul */}
      <div className="text-center mb-8">
        <h2 className="text-3xl md:text-4xl font-bold text-[#1e3e7e] font-roboto">
          Sebelum Memulai Tes
        </h2>
        <p className="mt-2 text-lg text-gray-600 font-open-sans">
          Sebaiknya kamu periksa 4 hal ini terlebih dahulu
        </p>
      </div>

      {/* Konten */}
      <div className="flex flex-col md:flex-row items-center justify-between">
        <div className="w-full md:w-1/2 flex justify-center mb-8 md:mb-0">
          <div className="w-56 h-56 md:w-72 md:h-72 bg-[#1e3e7e] rounded-full flex items-end justify-center overflow-hidden">
            <img
              src={Talent2}
              alt="Model pointing"
              className="w-44 h-44 md:w-60 md:h-60 object-cover rounded-full transform transition-transform duration-300 hover:scale-105"
            />
          </div>
        </div>

        {/* Langkah-langkah */}
        <div className="w-full md:w-1/2 space-y-6">
          {stepsData.map((step) => (
            <div
              key={step.number}
              className="flex items-center space-x-4 group hover:scale-105 transition-transform duration-300 cursor-pointer"
            >
              <div
                className={`w-10 h-10 ${step.circleColor} rounded-full flex items-center justify-center text-white font-bold font-poppins`}
              >
                {step.number}
              </div>
              <div>
                <h3 className={`text-xl font-semibold ${step.textColor} font-roboto`}>
                  {step.title}
                </h3>
                <p className="text-sm text-gray-600 font-open-sans">
                  {step.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default InstructionSection;
